<template>
	<div id="app">
		<a-layout v-if="!isLoginPage" class="layout">
			<a-layout-sider v-model="collapsed" :trigger="null" collapsible class="layout-sider">
				<left-menu></left-menu>
			</a-layout-sider>
			<a-layout class="layout-content">
				<top-menu v-model="collapsed"></top-menu>

				<a-layout class="layout-content">
					<a-layout-sider
						:style="{
							marginBottom: '24px',
							background: '#fff',
							paddingTop: '24px',
							maxWidth: '140px',
							minWidth: '0',
							flex: 'unset',
							width: 'auto',
						}"
					>
						<!-- <left-second-menu></left-second-menu> -->
					</a-layout-sider>
					<a-layout-content
						:style="{
							margin: '24px 16px',
							padding: '24px',
							background: '#fff',
							display: 'flex',
							width: '800px',
						}"
						:class="{ 'without-layout': withoutLayout }"
					>
						<!-- <keep-alive> -->
						<router-view v-if="isRouterAlive"></router-view>
						<!-- </keep-alive> -->
					</a-layout-content>
				</a-layout>
			</a-layout>
		</a-layout>
		<router-view v-else></router-view>
	</div>
</template>
<script>
import LeftMenu from "./components/left-menu";
import TopMenu from "./components/top-menu";
import LeftSecondMenu from "./components/left-second-menu";
import TagsView from "@/components/TagsView/index.vue";

const WITH_OUT_LAYOUT_ROUTE_NAME = ["ReviewOrderDetail", "OrderDetail"];

export default {
	data() {
		return {
			collapsed: false,
			isRouterAlive: true,
		};
	},
	provide() {
		return {
			reload: this.reload,
		};
	},
	computed: {
		isLoginPage() {
			return this.$route.path === "/login";
		},
		withoutLayout() {
			return (
				WITH_OUT_LAYOUT_ROUTE_NAME.includes(this.$route.name)
			);
		},
	},

	components: {
		LeftMenu,
		TopMenu,
		// TagsView
	},
	mounted() {},
	watch: {
		$route: {
			handler(newR, oldR) {
				if (newR.name == "OrderDetail" || newR.name == "ReviewOrderDetail") {
					document.querySelector(".ant-layout-content").scrollTo(0, 0);
				}
			},
		},
	},
	methods: {
		reload() {
			this.isRouterAlive = false;
			this.$nextTick(() => {
				this.isRouterAlive = true;
			});
		},
	},
};
</script>
<style lang="scss" scoped>
.layout {
	background-color: rgba(242, 248, 252, 1);
}
.ant-layout {
	height: 100vh;
	overflow: hidden;
}

.layout-sider {
	width: 207px;
	background-color: #FFFFFF;
	margin: 15px 12px 24px 24px;
	border-radius: 16px;
}

.layout-content {
	background-color: rgba(242, 248, 252, 1);
}

.ant-layout-content {
	overflow-y: auto;
	border-radius: 24px;
}
.without-layout {
	background: transparent !important;
	overflow: hidden;
	padding: 24px 0 !important;
	margin: 24px 0 !important;
}

.container {
	display: flex;
}
</style>
